import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../common/apiClient'

export interface MyTrainingStatus {
  outstanding: number
  selfReported: boolean
  user: { is_compliant: boolean; compliance_pct: number; security_score: string } | null
}

export const myTrainingQuery = (email: string) => ({
  queryKey: ['security-training-my-status', email.trim().toLowerCase()],
  queryFn: () => apiClient.get<MyTrainingStatus>(`/api/security-training/my-status?email=${encodeURIComponent(email.trim().toLowerCase())}`),
  staleTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: false,
})

/** The badge and personal training tab share one scoped, cached request. */
export function useMyTrainingStatus(email?: string) {
  const query = useQuery({ ...myTrainingQuery(email || ''), enabled: !!email })
  return { ...query, outstanding: query.data?.outstanding ?? 0 }
}
